const doc = [({"en":({"js":({"admin":({"contacts":({"show":({"uni_c":({"organization_relations":"Organization relations", "data":"Data"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;